var _rect, _rect2, _react, _use, _use2, _use3, _use4, _use5, _use6, _use7, _path, _g, _text, _text2, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "-100 -100 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 160,
    x: -60,
    y: -80,
    fill: "#3a4149"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 25,
    x: -20,
    y: -100,
    fill: "#3a4149"
  })), _react || (_react = /*#__PURE__*/React.createElement("react", {
    width: 100,
    height: 150,
    x: -100,
    y: -100,
    fill: "url(#parking-line-pattern)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-60)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-40)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-20)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,0)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,20)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,40)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,60)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M -50 -80 L -50 80",
    strokeWidth: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-60)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-40)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-20)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,0)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,20)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,40)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,60)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M -50 -80 L -50 80",
    strokeWidth: 0.6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(-30,75) rotate(270)",
    fontSize: 16,
    fontFamily: "Arial",
    opacity: 0.7,
    fill: "#FFF"
  }, "\r\n        P\r\n    ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(30,-75) rotate(90)",
    fontSize: 16,
    fontFamily: "Arial",
    opacity: 0.7,
    fill: "#FFF"
  }, "\r\n        P\r\n    ")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M -50 -75 L -50 75",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M -50 -75 L -50 75",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "parking-line"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(20,-5) rotate(270)",
    fontSize: 16,
    fontFamily: "Arial",
    opacity: 0.7,
    fill: "#FFF"
  }, "\r\n                P\r\n            "), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "     M 0 0      L 30 0     M 30 -2     L 30 2",
    strokeWidth: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.b1e45e23b17d3650ff135f66bd1400f1.svg";
export { ForwardRef as ReactComponent };